export const SET_CUSTOMER_VEHICLES = 'SET_CUSTOMER_VEHICLES';



// WEBPACK FOOTER //
// ./src/store/reducers/customerVehicles/actionTypes.js